import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

function InboxInlineCompose({ email, recipients = [], onSend, onClose }) {
    const [emailTo, setEmailTo] = useState([]);
    const [replyContent, setReplyContent] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let defaultTo = email.from;
        if (email.from === email.account) {
            defaultTo = email.to;
        }
        setEmailTo([{ value: defaultTo, label: defaultTo }]);
    }, [email]);

    const options = Array.from(new Set(recipients)).map(e => ({ value: e, label: e }));

    const canSend = replyContent.length > 0 && emailTo.length > 0 && !loading;

    async function handleSend() {
        setLoading(true);
        await onSend(email, emailTo, replyContent);
        setLoading(false);
    }

    return (
        <div className="inbox-reply-container">
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner-container">
                        <i className="fa-solid fa-spin fa-spinner"></i>
                        <span className="loading-text">Sending...</span>
                    </div>
                </div>
            )}
            <div className='inbox-reply-header'>
                <span>To:</span>
                <CreatableSelect
                    isMulti
                    styles={{
                        flex: 1,
                        control: (styles) => ({ ...styles, backgroundColor: 'white', border: 'none', boxShadow: 'none' }),
                    }}
                    onChange={setEmailTo}
                    value={emailTo}
                    placeholder="type email address"
                    options={options}
                />
            </div>
            <div
                contentEditable="true"
                onInput={e => setReplyContent(e.target.innerHTML)}
                className='inbox-compose-reply'>
            </div>

            <div className="inbox-reply-footer">
                <button
                    disabled={!canSend}
                    onClick={handleSend}
                    className="inbox-compose-send-button">
                    Send
                </button>

                <button
                    onClick={onClose}
                    className='inbox-button-transparent'
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Discard"
                >
                    <i className="fa-regular fa-trash-can"></i>
                </button>
            </div>
        </div>
    );
}

export default InboxInlineCompose;
